<template>
  <div class="column content-box">
    <woot-modal-header :header-title="pageTitle" />
    <form class="row" @submit.prevent="editAttributes">
      <div class="medium-12 columns">
        <woot-input
          v-model.trim="companyName"
          :label="selectedTable.company.name"
          :type="selectedTable.company.type != 'text' ? 'number' : 'text'"
          :class="{ error: $v.companyName.$error }"
          :error="
            $v.companyName.$error
              ? $t('ATTRIBUTES_MGMT.ADD.FORM.NAME.ERROR')
              : ''
          "
          :placeholder="selectedTable.company.name"
          @blur="$v.companyName.$touch"
        />
        <woot-input
          v-model.trim="clientCode"
          :label="selectedTable.client_code.name"
          :type="selectedTable.client_code.type != 'text' ? 'number' : 'text'"
          :class="{ error: $v.clientCode.$error }"
          :error="$v.clientCode.$error ? keyErrorMessage : ''"
          :placeholder="selectedTable.client_code.name"
          @blur="$v.clientCode.$touch"
        />
        <woot-input
          v-model.trim="status"
          :label="selectedTable.status.name"
          :type="selectedTable.status.type != 'text' ? 'number' : 'text'"
          :class="{ error: $v.status.$error }"
          :error="$v.status.$error ? keyErrorMessage : ''"
          :placeholder="selectedTable.status.name"
          @blur="$v.status.$touch"
        />
        <woot-input
          v-model.trim="monthlyFee"
          :label="selectedTable.monthly_fee.name"
          :type="selectedTable.monthly_fee.type != 'text' ? 'number' : 'text'"
          :class="{ error: $v.monthlyFee.$error }"
          :error="$v.monthlyFee.$error ? keyErrorMessage : ''"
          :placeholder="selectedTable.monthly_fee.name"
          @blur="$v.monthlyFee.$touch"
        />
        <woot-input v-if="selectedTable.custom_field_second.name"
          v-model.trim="firstCustom"
          :label="selectedTable.custom_field_first.name"
          :type="selectedTable.custom_field_first.type != 'text' ? 'number' : 'text'"
          :class="{ error: $v.firstCustom.$error }"
          :error="$v.firstCustom.$error ? keyErrorMessage : ''"
          :placeholder="selectedTable.custom_field_first.name"
          @blur="$v.firstCustom.$touch"
        />
        <woot-input v-if="selectedTable.custom_field_second.name"
          v-model.trim="secondCustom"
          :label="selectedTable.custom_field_second.name"
          :type="selectedTable.custom_field_second.type != 'text' ? 'number' : 'text'"
          :class="{ error: $v.secondCustom.$error }"
          :error="$v.secondCustom.$error ? keyErrorMessage : ''"
          :placeholder="selectedTable.custom_field_second.name"
          @blur="$v.secondCustom.$touch"
        />
      </div>
      <div class="modal-footer">
        <woot-button class="bg-primary" :is-loading="isUpdating" :disabled="isButtonDisabled">
          {{ $t('ATTRIBUTES_MGMT.EDIT.UPDATE_BUTTON_TEXT') }}
        </woot-button>
        <woot-button variant="clear" @click.prevent="onClose">
          {{ $t('ATTRIBUTES_MGMT.ADD.CANCEL_BUTTON_TEXT') }}
        </woot-button>
      </div>
    </form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    selectedAttribute: {
      type: Object,
      default: () => {},
    },
    selectedTable: {
      type: Object,
      default: () => {},
    },
    isUpdating: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      companyName: '',
      clientCode: '',
      monthlyFee: '',
      firstCustom: '',
      secondCustom: '',
      status: '',
    };
  },
  validations: {
    companyName: { required },
    clientCode:{},
    monthlyFee:{},
    firstCustom:{},
    secondCustom:{},
    status:{},
  },
  computed: {
    pageTitle() {
      return `${this.$t('ATTRIBUTES_MGMT.EDIT.TITLE')} - ${
        this.selectedAttribute.company
      }`;
    },
    isButtonDisabled() {
      return this.$v.$invalid;
    },
  },
  mounted() {
    this.setFormValues();
  },
  methods: {
    extractNumbers(input) {
      const numbers = String(input).replace(/\D/g, '');
      return parseInt(numbers, 10)*100;
    },
    verifyString(inputs,field){
      if (this.selectedTable[field].type != 'text'){
        return this.extractNumbers(inputs)
      }
      return inputs
    },
    verifyType(inputs,field){
      if (this.selectedTable[field].type != 'text'){
        return parseInt(inputs,10)/100
      }
      return inputs
    },
    onClose() {
      this.$emit('on-close');
    },
    setFormValues() {
  this.companyName = this.verifyType(this.selectedAttribute.company, 'company');
  this.status = this.verifyType(this.selectedAttribute.status, 'status');
  this.clientCode = this.verifyType(this.selectedAttribute.client_code, 'client_code');
  this.monthlyFee = this.verifyType(this.selectedAttribute.monthly_fee, 'monthly_fee');
  this.firstCustom = this.verifyType(this.selectedAttribute.custom_field_first, 'custom_field_first');
  this.secondCustom = this.verifyType(this.selectedAttribute.custom_field_second, 'custom_field_second');
},
    async editAttributes() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      try {
        await this.$store.dispatch('attributes/update', {
          id: this.selectedAttribute.id,
          table_id: this.selectedTable.id,
          company: this.verifyString(this.companyName,'company'),
          status: this.verifyString(this.status, 'status'),
          client_code: this.verifyString(this.clientCode, 'client_code'),
          monthly_fee:this.verifyString(this.monthlyFee,'monthly_fee'),
          custom_field_first: this.verifyString(this.firstCustom,'custom_field_first'),
          custom_field_second: this.verifyString(this.secondCustom,'custom_field_second'),
        });
        this.onClose();
      } catch (error) {
        console.error(error.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.key-value {
  padding: 0 var(--space-small) var(--space-small) 0;
  font-family: monospace;
}
</style>
